import type { FC } from 'react';
import type { LogoutBaseProps } from '@n3/pn-declaration';

import { redirectToLogout } from '@/common/utils/redirectToLogout';

export const LogoutBase: FC<LogoutBaseProps> = ({ className, children }) => (
  <button type="button" className={className} onClick={redirectToLogout}>
    {children}
  </button>
);
